<template>
    <div>
        <div>
            <b-form-checkbox
                v-model="createSheetMode"
                class="mb-2" switch>
                Nouvelle feuille
            </b-form-checkbox>
        </div>

        <div v-show="!createSheetMode">

            <div v-if="googleFilesSelect.length > 0">
                <label for="google_file_autocomplete">
                    Fichier Google Sheets cible
                </label>

                <Autocomplete
                    id="google_file_autocomplete"
                    class=" rounded-lg focus:outline-none"
                    @submit="(val) => selectedFile = val"
                    placeholder="Cherchez un fichier dans votre drive"
                    :defaultValue="''"
                    :search="(search) => autocompleteDriveFiles(search)"
                    :get-result-value="result => result"
                    :autoSelect="true">
                    <template #result="{ result, props }">
                        <li
                            v-bind="props"
                            class="autocomplete-result"
                        >
                            <div class="">
                                {{ result }}
                            </div>
                        </li>
                    </template>
                </Autocomplete>
            </div>

            <div v-show="fileSheets.length > 0">
                <label for="Range_input">
                    Nom de la feuille cible
                </label>
                <b-form-select
                    id="Range_input"
                    v-model="range"
                    :options="fileSheets"
                    class="mb-2">
                </b-form-select>
            </div>
            <hr/>
        </div>

        <div v-show="createSheetMode">
            <label for="new_sheet_name">Nom de la nouvelle feuille</label>
            <input
                id="new_sheet_name"
                class="rounded-md p-1 w-full leading-relaxed mb-2"
                v-model="newSheetName"
                placeholder="Nom de la nouvelle feuille"/>
            <hr/>
        </div>

        <div>
            <b-form-checkbox
                v-model="exportGed"
                class="mb-2"
                style="z-index: 0;"
                switch>
                Exporter un document.
            </b-form-checkbox>
        </div>

        <div v-if="exportGed === false">
            <label for="Table_name">Nom de la table SMD à exporter</label>
            <input
                id="Table_name"
                class="rounded-md p-1 w-full leading-relaxed mb-2"
                v-model="tableName"
                placeholder="Nom de la table SMD"/>
            <hr/>
        </div>
        
        <div v-if="exportGed">
            <label for="ged_file_autocomplete">Nom du document à exporter</label>
            <Autocomplete
                    id="ged_file_autocomplete"
                    class=" rounded-lg focus:outline-none mb-2"
                    @submit="(val) => selectedGedFile = val"
                    placeholder="Cherchez un fichier dans vos documents"
                    :defaultValue="''"
                    :search="(search) => autocompleteGedFiles(search)"
                    :get-result-value="result => result.text"
                    :autoSelect="true">
                    <template #result="{ result, props }">
                        <li
                            v-bind="props"
                            class="autocomplete-result"
                        >
                            <div class="">
                                {{ result.text }}
                            </div>
                            <div v-if="result.folder" class=" text-gray-400">
                                {{ "/" + result.folder}}
                            </div>
                        </li>
                    </template>
                </Autocomplete>
        </div>

        <div v-if="fieldsFilled">
            <b-button :variant="fieldsFilled ? 'success' : ''" :disabled="!fieldsFilled"
                @click="() => onValidate()">
                Valider
            </b-button>
        </div>
    </div>
</template>

<script setup>
import Autocomplete from "@trevoreyre/autocomplete-vue";
import { computed, onMounted, ref, watch } from "vue";

const props = defineProps({
    credentialName: {
        type: String,
        required: true
    },
    fileSheets: {
        type: Array,
        required: true
    },
    googleFilesSelect: {
        type: Array,
        required: true
    },
    autocompleteDriveFiles: {
        type: Function,
        required: true
    },

    autocompleteGedFiles: {
        type: Function,
        required: true
    },
});

const selectedFile = ref("");
const range = ref("");
const fileName = ref("");
const tableName = ref("");

const selectedGedFile = ref(null);

const createSheetMode = ref(false);
const newSheetName = ref("");

const emits = defineEmits(["createSheetFromGed", "updateSheetFromGed", "createSheetFromTable", "updateSheetFromTable", "reloadSheets"]);

const onValidate = () => {
    console.log("Validated");

    if (createSheetMode.value) {
        if (exportGed.value) {
            emits('createSheetFromGed', selectedGedFile.value, newSheetName.value);
        } else {
            emits('createSheetFromTable', tableName.value, newSheetName.value);
        }
    } else {
        if (exportGed.value) {
            emits('updateSheetFromGed', selectedFile.value, range.value, selectedGedFile.value);
        } else {
            emits('updateSheetFromTable', selectedFile.value, range.value, tableName.value);         
        }
    }
}

watch(() => props.googleFilesSelect, async (newVal, oldVal) => {
    if (newVal.length > 0) {
        selectedFile.value = "";
        // fileName.value = newVal[0].text;
        tableName.value = "";
    }
});

watch(() => props.fileSheets, async (newVal, oldVal) => {
    if (newVal.length > 0) {
        range.value = newVal[0].value;
        
        if (selectedFile.value.length > 0) {
            // filename and tablename are set
            tableName.value = selectedFile.value;
        }
    }
});

// watch selectedGedFile
watch(selectedGedFile, async (newVal, oldVal) => {
    console.log("Selected ged file updated: ", newVal);
    if (newVal) {
        newSheetName.value = newVal.text;
    }
});

const exportGed = ref(true);

const fieldsFilled = computed(() => {
    if (exportGed.value) {
        if (createSheetMode.value) {
            return newSheetName.value.length > 0 && selectedGedFile.value !== null && props.credentialName.length > 0;
        }
        return selectedFile.value.length > 0 && selectedGedFile.value !== null && props.credentialName.length > 0;
    } else {
        if (createSheetMode.value) {
            return newSheetName.value.length > 0 && tableName.value.length > 0 && props.credentialName.length > 0;
        }
        return selectedFile.value.length > 0 && tableName.value.length > 0 && props.credentialName.length > 0;
    }
});

watch(selectedFile, async (newVal, oldVal) => {
    // console.log("Selected file updated: ", newVal);
    emits("reloadSheets", newVal);
});

onMounted(async () => {
});

</script>